
import { PropType } from "vue";
import { Vue, Options } from "vue-class-component";

@Options({
  props: {
    onClose: {
      default: Function as PropType<() => void>,
      type: Function
    },
    data: {
      default: [],
      type: Array
    }
  }
})
export default class ModalListCourier extends Vue {}
